import React, { useEffect, useState } from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import Login from '../components/login';
import Home from './home';
import TextEditor from '../components/TextEditor';
import Loader from '../components/loader';
import Axios from 'axios';
import Error401 from './error/E401';

export default function Auth() {

    const [isLoggedIn, setLoggedIn] = useState(null);

    useEffect(async () => {
        const data = JSON.parse(localStorage.getItem('authData'));
        // console.log("-----");
        //console.log(data);
        if(data === null)
        {
            setLoggedIn(false);
        }
        
        else
        {
            //console.log(data);
            const url = `https://docsserver.onrender.com/getToken/verify`;

            try
            {
                const res = await Axios.post(url, data);
                //console.log(res);
                if(res.data == "Verified user")
                {
                    setLoggedIn(true);
                }
                else{
                    setLoggedIn(false);
                }
            }
            catch(err)
            {
                setLoggedIn(false);
                //console.log("Error");
            }
        }
    }, [])
   
    if(isLoggedIn == null)
    {
        return(
            <Loader />
        )
    }

    else if(!isLoggedIn)
    {
        return (
            <Router>
                <Routes>
                    <Route path='/login' exact element={<Login />} />
                    <Route path='*' element={<Navigate to='/login' />} />
                </Routes>
            </Router>
        )
    }

    return (
        <Router>
          <Routes>
            <Route path='/' exact element={<Home />} />
            <Route path='/getDocx' exact element={<Navigate replace to={`/document/:id`}/>} />
            <Route path='/document/:id' exact element={<TextEditor />} />
            <Route path='/login' element={<Navigate to='/' />} />
            <Route path='/unauthorized' element={<Error401 />} />
          </Routes>
        </Router>
      )
}
